 <script>
   import { navigate } from 'svelte-routing';
   import axios from 'axios';
   let username = '';
   let password = '';
   let error = '';
   let success = '';

   async function handleLogin() {
       error = '';
       success = '';
       try {
           const response = await axios.post('https://noondev.pythonanywhere.com/authapi/login/', {
               username,
               password
           });
           console.log('Response:', response.data); // Log de la réponse pour débogage
           const { token } = response.data;
           localStorage.setItem('token', token);
           success = 'Connexion réussie ! Redirection vers le tableau de bord...';
           // Rediriger après un court délai pour permettre l'affichage du message de succès
           setTimeout(() => {
               navigate('/dashboard');
           }, 2000);
       } catch (err) {
           console.error('Error:', err.response); // Log de l'erreur pour débogage
           if (err.response && err.response.data) {
               error = err.response.data.error || 'Connexion échouée. Vérifiez votre nom d’utilisateur et votre mot de passe.';
           } else {
               error = 'Connexion échouée. Une erreur s\'est produite.';
           }
       }
   }
</script>

<style>
   .login-container {
       display: flex;
       flex-direction: column;
       align-items: center;
       justify-content: center;
       height: 100vh;
       background-color: #f9f9f9;
       padding: 20px;
   }

   h1 {
       color: #333;
   }

   form {
       display: flex;
       flex-direction: column;
       width: 300px;
   }

   input {
       margin-bottom: 10px;
       padding: 10px;
       border: 1px solid #ccc;
       border-radius: 5px;
   }

   button {
       padding: 10px;
       background-color: #0070f3;
       color: white;
       border: none;
       border-radius: 5px;
       cursor: pointer;
   }

   button:hover {
       background-color: #005bb5;
   }

   p {
       color: red;
   }

   .success {
       color: green;
   }
</style>

<div class="login-container">
   <h1>Connexion</h1>
   <form on:submit|preventDefault={handleLogin}>
       <input type="text" bind:value={username} placeholder="Nom d'utilisateur" required />
       <input type="password" bind:value={password} placeholder="Mot de passe" required />
       <button type="submit">Se connecter</button>
       {#if error}
           <p>{error}</p>
       {/if}
       {#if success}
           <p class="success">{success}</p>
       {/if}
   </form>
</div>


<!-- 
const response = await axios.post('https://noondev.pythonanywhere.com/authapi/login/', {
const response = await axios.post('http://127.0.0.1:8000/authapi/login/', { 
-->